module.exports = __webpack_public_path__ + "static/media/li.3eda9002.webp";